import * as React from "react";
import type { SVGProps } from "react";
const SvgMandatoryCosts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mandatory-costs_svg__a)">
      <path d="M11 20a6.54 6.54 0 0 1-5-2.34 8.9 8.9 0 0 1 0-11.2A6.56 6.56 0 0 1 11 4a6.53 6.53 0 0 1 5 2.34 1 1 0 1 1-1.5 1.32A4.58 4.58 0 0 0 11 6a4.59 4.59 0 0 0-3.48 1.74 6.83 6.83 0 0 0 .07 8.6 4.42 4.42 0 0 0 6.9 0A1.002 1.002 0 1 1 16 17.66 6.54 6.54 0 0 1 11 20" />
      <path d="M11 15H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0-4H3a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2M21 15a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v7a1 1 0 0 1-1 1M21 18a1.05 1.05 0 0 1-.71-.29 1 1 0 0 1-.21-.33.94.94 0 0 1 0-.76 1.2 1.2 0 0 1 .21-.33 1 1 0 0 1 .91-.29l.18.06a.8.8 0 0 1 .18.09l.15.12q.133.147.21.33a.94.94 0 0 1 0 .76q-.077.183-.21.33l-.15.12a.8.8 0 0 1-.18.09l-.18.1z" />
    </g>
    <defs>
      <clipPath id="mandatory-costs_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMandatoryCosts;
